import { Text } from "@overmap-ai/blocks"
import { type AssetType } from "@overmap-ai/common"
import { selectAssetTypeById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { AssetTypeIcon } from "../../../../components/Icons/AssetTypeIcon"
import { useAppSelector } from "../../../../store"

export const AssetTypeMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: AssetType["uuid"] }

	const assetType = useAppSelector(selectAssetTypeById(uuid))

	return (
		<NodeViewWrapper className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1" as="span">
			{!!assetType && (
				<Link
					className="whitespace-nowrap"
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/asset-types/$assetTypeId"
					params={(prev) => ({ ...prev, assetTypeId: assetType.uuid })}
				>
					<AssetTypeIcon assetTypeId={assetType.uuid} background={false} className="align-sub" />
					<Text className="truncate">{assetType.name}</Text>
				</Link>
			)}
		</NodeViewWrapper>
	)
})
AssetTypeMentionComponent.displayName = "AssetTypeMentionComponent"
